import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabOutcome from '../../form-fields/tab-outcome/tab-outcome';
class AddEditViewReferralTabOutcome extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabOutcome {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
AddEditViewReferralTabOutcome.propTypes = {
  locked: PropTypes.bool,
}
AddEditViewReferralTabOutcome = reduxForm({
  form: 'ReferralEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddEditViewReferralTabOutcome);
export default AddEditViewReferralTabOutcome;